<template>
  <div
    class="modal modal-overlay"
    tabindex="-1"
    role="dialog"
    id="Modal_Mensagem"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content card-container">
        <div class="modal-header">
          <div class="card-title gy-4">
            <i class="bi bi-pencil-square fs-5 icon-text-logout"></i>
            <span class="txt-title-modal">Informação</span>
          </div>          
        </div>
        <div class="modal-body bg-info-msg text-center">
          <p class="fs-6 fw-bold">{{ msg }}</p>
        </div>     
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Message",
  props: {
    msg: String,
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* escurece o fundo */
  z-index: 1060; /* sobrepõe outros modais */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>